import React from 'react'

import NationalResult from '../../../models/NationalResult'
import Party from '../../../models/Party'
import ProvincialResultTableRow from './ProvincialResultTableRow'

interface IProps {
  nationalResult: NationalResult
}

class ProvincialResultTable extends React.Component<IProps> {
  public render(): JSX.Element {
    const { nationalResult } = this.props

    const partyHeaders = Party.allPartiesArray().map(
      (party): JSX.Element => <th key={party.key}>{party.key}</th>
    )

    const provincialRows = nationalResult
      .provincialResults()
      .map(
        (provincialResult): JSX.Element => (
          <ProvincialResultTableRow
            key={provincialResult.province.key}
            provincialResult={provincialResult}
          />
        )
      )

    return (
      <div>
        <h2>Provincial results</h2>
        <table className="table text-right">
          <thead>
            <tr>
              <th className="text-right pr-3" style={{ maxWidth: '300px' }}>
                Province
              </th>
              <th />
              {partyHeaders}
            </tr>
          </thead>
          <tbody>{provincialRows}</tbody>
        </table>
      </div>
    )
  }
}

export default ProvincialResultTable
